import { z } from 'zod';

/**
 * Common metadata type definitions
 * 
 * Metadata fields are flexible key-value stores that can contain
 * various additional information. Use Zod's catchall for validation
 * while maintaining type safety.
 */

// Base metadata schema - allows any string keys with flexible values
export const metadataSchema = z.record(z.string(), z.unknown());

// Infer TypeScript type
export type Metadata = z.infer<typeof metadataSchema>;

// More specific metadata schemas can be created as needed
// Example: Transaction metadata
export const transactionMetadataSchema = z.object({
  // Known fields
  paymentMethod: z.string().optional(),
  referenceNumber: z.string().optional(),
  externalId: z.string().optional(),
  // Catchall for unknown fields
}).catchall(z.unknown());

export type TransactionMetadata = z.infer<typeof transactionMetadataSchema>;

// Communication metadata
export const communicationMetadataSchema = z.object({
  deliveryStatus: z.string().optional(),
  providerId: z.string().optional(),
  messageId: z.string().optional(),
  // Catchall for unknown fields
}).catchall(z.unknown());

export type CommunicationMetadata = z.infer<typeof communicationMetadataSchema>;

// File metadata
export const fileMetadataSchema = z.object({
  s3Key: z.string().optional(),
  s3Url: z.string().optional(),
  contentType: z.string().optional(),
  size: z.number().optional(),
  // Catchall for unknown fields
}).catchall(z.unknown());

export type FileMetadata = z.infer<typeof fileMetadataSchema>;
